module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-page"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('section', [_vm._m(0), _c('h1', [_vm._v(_vm._s(_vm.$route.meta.title))])]), _c('section', [_c('div', {
    staticClass: "tab-wrap"
  }, _vm._l((_vm.tabs), function(tab, index) {
    return _c('div', {
      staticClass: "tab-item",
      class: {
        actived: _vm.nowTab === index
      },
      on: {
        "click": function($event) {
          _vm.nowTab = index
        }
      }
    }, [_vm._v(_vm._s(tab.name))])
  }))]), _c('div', {
    staticClass: "mb-10"
  }), (_vm.nowTab === 0) ? _c('section', {
    staticClass: "shop-link"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_vm._v("WF 系列周邊")]), _vm._m(1), _vm._m(2), _vm._m(3), _c('div', {
    staticClass: "mb-10"
  }), _vm._m(4)]) : _vm._e(), _c('div', {
    staticClass: "mb-10"
  }), (_vm.nowTab === 1) ? _c('section', {
    staticClass: "shop-link"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_vm._v("4Gamers Shop 特色商品")]), _vm._m(5), _c('div', {
    staticClass: "mb-10"
  }), _vm._m(6), _c('div', {
    staticClass: "mb-40"
  })]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-decoration"
  }, [_c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "png-shadow",
    attrs: {
      "href": "https://www.elementaltotem.com/pages/wirforce",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("assets/shopping/shop1.png")
    }
  }), _c('div', {
    staticClass: "mb-8"
  }), _c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("assets/shopping/shop2.png")
    }
  }), _c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("assets/shopping/shop3.png")
    }
  }), _c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("assets/shopping/shop4.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "box-shadow",
    attrs: {
      "href": "https://www.elementaltotem.com/products/castle-shelving-designed-for-byoc",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("assets/shopping/ET.jpg")
    }
  }), _c('div', {
    staticClass: "mb-16"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "png-shadow",
    attrs: {
      "href": "https://www.elementaltotem.com/pages/wirforce",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("assets/shopping/ET_1016.png")
    }
  }), _c('div', {
    staticClass: "mb-16"
  }), _c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("assets/shopping/ET_0927.png")
    }
  }), _c('div', {
    staticClass: "mb-16"
  }), _c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("assets/shopping/ET_1017.png")
    }
  }), _c('div', {
    staticClass: "mb-8"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a', {
    staticClass: "btn ghost-btn red",
    attrs: {
      "href": "https://www.elementaltotem.com/pages/wirforce",
      "target": "_blank"
    }
  }, [_vm._v("前往商店")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "box-shadow",
    attrs: {
      "href": "https://shop.4gamers.com.tw/",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "add-margin",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("assets/shopping/4g06.png")
    }
  }), _c('img', {
    staticClass: "add-margin",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("assets/shopping/4g01.png")
    }
  }), _c('img', {
    staticClass: "add-margin",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("assets/shopping/4g02.png")
    }
  }), _c('img', {
    staticClass: "add-margin",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("assets/shopping/4g03.png")
    }
  }), _c('img', {
    staticClass: "add-margin",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("assets/shopping/4g04.png")
    }
  }), _c('img', {
    staticClass: "add-margin",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("assets/shopping/4g05.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a', {
    staticClass: "btn ghost-btn red",
    attrs: {
      "href": "https://shop.4gamers.com.tw/",
      "target": "_blank"
    }
  }, [_vm._v("前往 4Gamers Shop")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5fad0184"}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shopping.vue
// module id = 571
// module chunks = 1